import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';

const NetatmoCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Traitement de l\'authentification Netatmo...');

  useEffect(() => {
    handleCallback();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallback = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (error) {
        console.error('Erreur OAuth Netatmo:', error);
        setStatus('error');
        setMessage(`Erreur d'authentification: ${error}`);
        
        setTimeout(() => {
          navigate('/rain');
        }, 3000);
        return;
      }

      if (!code || !state) {
        console.error('Paramètres d\'authentification manquants');
        setStatus('error');
        setMessage('Paramètres d\'authentification manquants');
        
        setTimeout(() => {
          navigate('/rain');
        }, 3000);
        return;
      }

      setMessage('Échange du code d\'autorisation...');

      // Échanger le code contre un token via Cloud Function
      const baseUrl = process.env.NODE_ENV === 'development' 
        ? 'http://localhost:5001/theapp-428906/us-central1'
        : 'https://us-central1-theapp-428906.cloudfunctions.net';

      const response = await fetch(`${baseUrl}/exchangeNetatmoCode`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code, state })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erreur lors de l\'échange du code');
      }

      const result = await response.json();
      
      if (result.success) {
        setStatus('success');
        setMessage('Authentification Netatmo réussie ! Redirection...');
        
        setTimeout(() => {
          navigate('/rain?netatmo_auth=success');
        }, 2000);
      } else {
        throw new Error('Échec de l\'authentification');
      }
    } catch (error) {
      console.error('Erreur callback Netatmo:', error);
      setStatus('error');
      setMessage(`Erreur: ${error.message}`);
      
      setTimeout(() => {
        navigate('/rain?netatmo_auth=error');
      }, 3000);
    }
  };

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
      padding={3}
    >
      <Box marginBottom={3}>
        {status === 'loading' && <CircularProgress size={60} />}
        {status === 'success' && (
          <Box 
            width={60} 
            height={60} 
            borderRadius="50%" 
            bgcolor="success.main" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
          >
            <Typography variant="h4" color="white">✓</Typography>
          </Box>
        )}
        {status === 'error' && (
          <Box 
            width={60} 
            height={60} 
            borderRadius="50%" 
            bgcolor="error.main" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
          >
            <Typography variant="h4" color="white">✗</Typography>
          </Box>
        )}
      </Box>

      <Typography variant="h5" align="center" gutterBottom>
        {status === 'loading' && 'Authentification Netatmo'}
        {status === 'success' && 'Authentification réussie'}
        {status === 'error' && 'Erreur d\'authentification'}
      </Typography>

      <Typography variant="body1" align="center" color="textSecondary">
        {message}
      </Typography>

      {status === 'error' && (
        <Alert severity="error" style={{ marginTop: 16, maxWidth: 400 }}>
          Une erreur est survenue lors de l'authentification. Vous allez être redirigé vers la page principale.
        </Alert>
      )}
    </Box>
  );
};

export default NetatmoCallback;